"use client";

import { useQuery } from "@tanstack/react-query";
import { fetchEnrollmentById } from "@/features/enrollments/shared/fetchEnrollmentById";
import { useAccessToken, useTenantData } from "@/hooks/shared";
import { QueryKeys } from "@/lib/types";

export const enrollmentByIdQueryKey = (enrollmentId: number) =>
  [QueryKeys.ClassesEnrollmentsByStudentId, "by-id", enrollmentId] as const;

export function useEnrollmentById(
  enrollmentId: number | null,
  enabled: boolean,
) {
  const accessToken = useAccessToken();
  const { tenantId } = useTenantData();

  return useQuery({
    queryKey: enrollmentByIdQueryKey(enrollmentId ?? 0),
    enabled:
      enabled &&
      enrollmentId != null &&
      enrollmentId > 0 &&
      Boolean(accessToken),
    queryFn: async () => {
      if (!accessToken || enrollmentId == null) return null;
      return fetchEnrollmentById(accessToken, tenantId, enrollmentId);
    },
    staleTime: 30_000,
  });
}
